/** Donation Helper */
import moment from "moment";

export const displayNextDonationDate = (
  donation,
  date_format = "Do [of] MMM YYYY"
) => {
  // Define variables.
  const date_now = moment();
  let date_next = "";
  let date_increase_amount = 1;
  let date_increase_duration = "days";

  // If we have a donation...
  if (
    typeof donation !== "undefined" &&
    typeof donation.debit_date === "string" &&
    donation.debit_date !== ""
  ) {
    date_next = moment(donation.debit_date);

    // Check the schedule and update the variables.
    switch (donation.donation_schedule) {
      case "Weekly":
        date_increase_amount = 1;
        date_increase_duration = "weeks";
        break;

      case "Monthly":
        date_increase_amount = 1;
        date_increase_duration = "months";
        break;

      case "Fortnightly":
        date_increase_amount = 2;
        date_increase_duration = "weeks";
        break;

      case "Quarterly":
        date_increase_amount = 3;
        date_increase_duration = "months";
        break;

      case "Half Yearly":
      case "Half-Yearly":
        date_increase_amount = 6;
        date_increase_duration = "months";
        break;

      case "Annually":
        date_increase_amount = 1;
        date_increase_duration = "years";
        break;

      default:
    }

    // If we have a valid next date...
    if (typeof date_next === "object" && date_next.isValid()) {
      // If the date is not in the future
      if (date_next.isAfter(date_now) === false) {
        // Increase the next donation date.
        date_next = moment(date_next).add(
          date_increase_amount,
          date_increase_duration
        );
      }

      return date_next.format(date_format);
    }
  }

  return "";
};
